import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/map.svg'
import _imports_1 from '@/assets/images/usa.svg'
import _imports_2 from '@/assets/images/germany.svg'
import _imports_3 from '@/assets/images/united-kingdom.svg'
import _imports_4 from '@/assets/images/canada.svg'
import _imports_5 from '@/assets/images/portugal.svg'
import _imports_6 from '@/assets/images/spain.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Most Sales Location"),
        _createElementVNode("div", { class: "dropdown action-opt" }, [
          _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { "data-feather": "more-horizontal" })
          ]),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "clock" }),
                _createTextVNode(" Today ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "pie-chart" }),
                _createTextVNode(" Last 7 Days ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "rotate-cw" }),
                _createTextVNode(" Last Month ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "calendar" }),
                _createTextVNode(" Last 1 Year ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "bar-chart" }),
                _createTextVNode(" All Time ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "eye" }),
                _createTextVNode(" View ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "trash" }),
                _createTextVNode(" Delete ")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "text-center",
        style: {"margin":"33px 0"}
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "map"
        })
      ]),
      _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled sales_by_locations mt-4" }, [
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "wh-30 rounded-circle",
              alt: "usa"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "United States"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "85",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar",
                style: {"width":"85%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "85%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "wh-30 rounded-circle",
              alt: "germany"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Germany"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "75",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-danger",
                style: {"width":"75%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "75%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_3,
              class: "wh-30 rounded-circle",
              alt: "united-kingdom"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "United Kingdom"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "40",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-success",
                style: {"width":"40%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "40%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_4,
              class: "wh-30 rounded-circle",
              alt: "canada"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Canada"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "10",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary-div",
                style: {"width":"10%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "10%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_5,
              class: "wh-30 rounded-circle",
              alt: "portugal"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Portugal"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "05",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar",
                style: {"width":"05%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "05%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_6,
              class: "wh-30 rounded-circle",
              alt: "spain"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Spain"),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "15",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-secondary bg-opacity-50",
                style: {"width":"15%"}
              }, [
                _createElementVNode("span", { class: "count fw-medium text-body" }, "15%")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}